<template>
  <div>
    <header-component />
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header d-flex align-items-center justify-content-between flex-wrap gap-2">
          <h3 class="mb-0">Staff Members</h3>
          <input
            v-model="search"
            class="form-control form-control-sm"
            style="width: 220px"
            placeholder="Search by name..."
            @input="onSearch"
          />
        </div>

        <div class="overflow-x-auto">
          <table class="min-w-full bg-white border border-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Role</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Phone</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Current Branch</th>
                <th class="px-4 py-3"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="5" class="text-center py-10 text-gray-400">Loading...</td>
              </tr>
              <tr v-else-if="staff.length === 0">
                <td colspan="5" class="text-center py-10 text-gray-400">No staff members found.</td>
              </tr>
              <tr
                v-for="row in staff"
                :key="row.user_id"
                class="hover:bg-gray-50 border-b"
              >
                <td class="px-4 py-3 text-sm text-gray-800">{{ row.name }}</td>
                <td class="px-4 py-3">
                  <span class="px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
                    {{ row.role_label }}
                  </span>
                </td>
                <td class="px-4 py-3 text-sm text-gray-700" style="white-space: nowrap">{{ row.phone }}</td>
                <td class="px-4 py-3 text-sm text-gray-700">
                  <span
                    v-if="row.branch_name"
                    class="inline-flex px-2 py-0.5 text-xs font-semibold rounded-full"
                    :style="branchBadgeStyle(row.branch_name)"
                  >{{ row.branch_name }}</span>
                  <span v-else>—</span>
                </td>
                <td class="px-4 py-3 text-right">
                  <base-button size="sm" type="primary" @click="editStaff(row)">Edit</base-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { apiHelper } from "@/utils/helpers";
import endpoints from "@/utils/constants";
import headerComponent from "../Components/HeaderComponent";

export default {
  components: {
    "header-component": headerComponent,
  },
  data() {
    return {
      staff: [],
      allBranches: [],
      search: "",
      loading: false,
      searchTimeout: null,
    };
  },
  mounted() {
    this.fetchBranches();
    this.fetchStaff();
  },
  methods: {
    ...mapActions({ fetchUser: "user/fetchUser" }),

    fetchBranches() {
      apiHelper
        .call("get", `${endpoints.LARAVEL_BASE_URL}/api/v1/branches`)
        .then((res) => { this.allBranches = res.data.data || res.data; })
        .catch(() => {});
    },

    branchBadgeStyle(branchName) {
      const b = this.allBranches.find((x) => x.name === branchName);
      if (!b || !b.color) return { background: '#dbeafe', color: '#1e40af' };
      return { background: b.color, color: '#fff' };
    },

    fetchStaff() {
      this.loading = true;
      const url = `${endpoints.LARAVEL_BASE_URL}/api/v1/staff-users${this.search ? `?search=${encodeURIComponent(this.search)}` : ""}`;
      apiHelper
        .call("get", url)
        .then((res) => {
          this.staff = res.data.users || [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onSearch() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => this.fetchStaff(), 350);
    },

    editStaff(row) {
      this.fetchUser(row.user_id).then(() => {
        this.$router.push("/users/add/" + row.user_id);
      });
    },
  },
};
</script>
